import { ExternalLink, Modal, Text } from '@ui/themed';
import { t } from 'i18next';
import type { I18nPrefix } from '../../../../i18n/prefix';
import { PARTNER_DOCS_URLS } from '../../constants';
import type { PartnerModalProps } from '../../types';
import { usePartnerModalSave } from './shared';

const SUFIO = 'features:partners.components.sufio' satisfies I18nPrefix;
const COMMON = 'features:partners.components.common' satisfies I18nPrefix;

export function SufioModal({ isOpen, onClose }: PartnerModalProps) {
  const { save, isSaving } = usePartnerModalSave(onClose);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      secondaryAction={{ text: t(`${COMMON}.close`), onClick: onClose }}
      primaryAction={{
        text: t(`${COMMON}.save`),
        onClick: () => void save([{ key: 'integrationSufio', value: true }]),
        loading: isSaving,
      }}
    >
      <Modal.Header>Sufio</Modal.Header>
      <Modal.Body>
        <Text variant="secondary">
          {t(`${SUFIO}.description`)}{' '}
          <ExternalLink link={PARTNER_DOCS_URLS.sufio} showIcon>
            {t(`${SUFIO}.follow_our_guide`)}
          </ExternalLink>
        </Text>
      </Modal.Body>
    </Modal>
  );
}
